import EventsAthleteDashboard from "./Events";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import AthleteScore from "../../../components/athlete-scores/athlete-score";

function AthleteDashboard() {
  const authUser = useAuthUser();

  return (
    <>
      <div className="flex p-4 h-full bg-gray-100 pb-20 md:pb-20 xl:pb-6 lg:pb-24">
        <div className="flex flex-col sm:flex-row w-full">
          <div className="w-full sm:w-3/5">
            <div className="h-full">
              <AthleteScore
                userId={authUser?.user?.id}
                showOffers={true}
                showTrackittScore={true}
                showPositionScore={true}
                searchEvent={false}
                showProfile={true}
                showRank={true}
                showLikes={true}
                sharedProfile={false}
              />
            </div>
          </div>
          <div className="w-full sm:w-2/5 md:pl-4 xl:pl-4 lg:pl-4 p-4  sm:pt-0 sm:pb-0 px-0 pt-6 pb-6">
            <div className="grid grid-cols-1 gap-y-3 h-full">
              <div>
                <EventsAthleteDashboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AthleteDashboard;
